/**
 * Date-extensions locale Yoruba Nigeria [yo]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('yo', {
    monthNames: ['Sẹ́rẹ́','Èrèlè','Ẹrẹ̀nà','Ìgbé','Èbibi','Òkùdu','Agẹmo','Ògún','Owewe','Ọ̀wàrà','Bélú','Ọ̀pẹ̀̀'],
    monthShortNames: ['Sẹ́r','Èrl','Ẹrn','Ìgb','Èbi','Òkù','Agẹ','Ògú','Owe','Ọ̀wà','Bél','Ọ̀pẹ̀̀'],
    dayNames: ['Àìkú','Ajé','Ìsẹ́gun','Ọjọ́rú','Ọjọ́bọ','Ẹtì','Àbámẹ́ta'],
    dayShortNames: ['Àìk','Ajé','Ìsẹ́','Ọjr','Ọjb','Ẹtì','Àbá']
});
